import styled, { css } from 'styled-components';
import { HeadingStyle } from 'components/heading';
import { TextStyle } from 'components/text';
import { FontSize } from 'commons';

export const Wrapper = styled.div`
  clear: both;
  page-break-inside: avoid;
  page-break-after: always;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  max-width: 8cm;
  height: 100vh;
  max-height: 4cm;
  padding: 5px 1cm;
  font-size: 12px;

  * {
    font-family: Arial, Helvetica, sans-serif;
  }

  ${TextStyle} {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  ${HeadingStyle} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
  }

  @media only screen {
    background-color: #fff;
  }
`;

export const HorizontalWrapper = styled(Wrapper)`
  flex-direction: row;
  align-items: center;
  gap: 15px;
`;

export const Main = styled.div`
  width: 10cm;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${Wrapper}:last-child {
    page-break-after: avoid;
  }

  @media only screen {
    align-items: unset;
    gap: 10px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .special-case {
    max-width: 64px;
    text-align: center;
  }
`;

const postions = {
  start: css`
    align-items: center;
    gap: 10px;
  `,
  end: css`
    flex: 1;
    overflow: hidden;
  `,
};

export const StoreSection = styled.div<{ $position: 'start' | 'end' }>`
  display: flex;
  flex-direction: column;
  justify-self: center;

  ${({ $position }) => postions[$position]}
`;

export const CustomerSection = styled.div<{ $startSection?: boolean }>`
  display: flex;

  ${({ $startSection }) =>
    $startSection &&
    css`
      overflow: hidden;
      flex-direction: column;
    `}
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    display: flex;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  margin-bottom: 5px;
`;

export const PhoneWrapper = styled.div`
  svg {
    height: 10px;
    width: 10px;
  }

  ${TextStyle} {
    font-size: ${FontSize.font10};
  }
`;

export const Icon = styled.div`
  display: flex;
  height: 14px;
  width: 14px;
`;
